'use client';

// Third Party
import { c as _c } from "react/compiler-runtime";
import * as React from 'react';

// Utils
import { useToggle } from '@hooks';
export type MobileSearchModalContextValue = {
  activateMobileSearchModal: VoidFunction;
  deactivateMobileSearchModal: VoidFunction;
  mobileSearchModalActive: boolean;
};
interface Props {
  children: React.ReactNode;
}
export const MobileSearchModalProvider: React.FC<Props> = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    on: mobileSearchModalActive,
    setOn: activateMobileSearchModal,
    setOff: deactivateMobileSearchModal
  } = useToggle(false);
  let t1;
  if ($[0] !== activateMobileSearchModal || $[1] !== deactivateMobileSearchModal || $[2] !== mobileSearchModalActive) {
    t1 = {
      activateMobileSearchModal,
      deactivateMobileSearchModal,
      mobileSearchModalActive
    };
    $[0] = activateMobileSearchModal;
    $[1] = deactivateMobileSearchModal;
    $[2] = mobileSearchModalActive;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const contextValue = t1;
  let t2;
  if ($[4] !== children || $[5] !== contextValue) {
    t2 = <MobileSearchModalContext.Provider value={contextValue}>{children}</MobileSearchModalContext.Provider>;
    $[4] = children;
    $[5] = contextValue;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const MobileSearchModalContext = React.createContext<MobileSearchModalContextValue | undefined>(undefined);
export const useMobileSearchModal = () => {
  const context = React.useContext(MobileSearchModalContext);
  if (context === undefined) {
    throw new Error("useMobileSearchModal must be used within a MobileSearchModalProvider");
  }
  return context;
};